module.exports = __webpack_public_path__ + "static/media/about-img-4@2x.3b5cf43b.png";